import _jsx from "@babel/runtime/helpers/jsx";
import React, { useState, createContext, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
export const AccordionContext = /*#__PURE__*/createContext({
  activeEventKeys: [],
  handleToggle: () => {}
});

/**
 * Accordion, with child AccordionPanels, groups collapsible content areas
 *
 */
function Accordion(_ref) {
  let {
    className,
    bsStyle = 'default',
    onToggle = () => {},
    onOpen = () => {},
    onClose = () => {},
    children,
    defaultActiveKey,
    ...rest
  } = _ref;
  /* state variable used to keep track of which accordion panels were toggled
   * this is used in conjunction with the prop defaultActiveKey to concatenate into
   * an array which is used by each child AccordionPanel to know if it should be collapsed/expanded */
  const [localActiveEventKeys, setActiveEventKeys] = useState([].concat(defaultActiveKey));
  const onToggleHandle = useCallback(eventKey => {
    let eventKeys = [].concat(localActiveEventKeys);
    if (eventKeys.includes(eventKey)) {
      eventKeys = eventKeys.filter(key => key !== eventKey);
      onClose(eventKey);
    } else {
      eventKeys = eventKeys.concat(eventKey);
      onOpen(eventKey);
    }
    onToggle(eventKey);
    setActiveEventKeys(eventKeys);
  }, [localActiveEventKeys, onClose, onOpen, onToggle]);
  delete rest.defaultActiveKey;
  const rootClassName = clsx({
    accordion: true,
    [`accordion-${bsStyle}`]: bsStyle
  }, className);
  const value = useMemo(() => ({
    activeEventKeys: localActiveEventKeys,
    handleToggle: onToggleHandle
  }), [localActiveEventKeys, onToggleHandle]);
  return /*#__PURE__*/_jsx(AccordionContext.Provider, {
    value: value
  }, void 0, /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "accordion",
    className: rootClassName
  }, rest), children));
}
export default Accordion;